
export const getFaqParentCssId = (contentLayoutModule: any): string | null =>
  contentLayoutModule?.contentModule?.settings?.parentCssId ?? contentLayoutModule?.settings?.parentCssId ?? null;

export const isFaqChild = (contentLayoutModule: any): boolean => !!getFaqParentCssId(contentLayoutModule);

const getSortOrder = (contentLayoutModule: any): number =>
  contentLayoutModule?.contentModule?.settings?.sortOrder ?? contentLayoutModule?.settings?.sortOrder ?? 0;

export const FIRST_QUESTION_KEY = 'q1';

export const getFaqQuestions = (settings: any): any[] => {
  const list = Array.isArray(settings?.questions) ? settings.questions.filter((q: any) => q?.key) : [];
  return list.length ? list : [{ key: FIRST_QUESTION_KEY, title: settings?.title ?? {} }];
};

const childQuestionKey = (clm: any): string => clm?.contentModule?.settings?.parentKey ?? clm?.settings?.parentKey ?? FIRST_QUESTION_KEY;

export const getFaqChildren = (contentLayoutModules: any[], cssId?: string | null, questionKey: string = FIRST_QUESTION_KEY): any[] => {
  if (!cssId) return [];
  return (contentLayoutModules ?? [])
    .filter(clm => !clm.deleted && getFaqParentCssId(clm) === cssId && childQuestionKey(clm) === questionKey)
    .sort((a, b) => getSortOrder(a) - getSortOrder(b));
};
